// 基础信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

// 缺失 合作方式
// 缺失 门店品类

export default (state) => {
  let baseDetail = get(state, 'currentShopBaseDetail', {})
  let currentDish = get(state, 'currentDish', {})

  return [
    {
      title: i18n.gettext('门店名称'),
      label: baseDetail.name
    },
    {
      title: i18n.gettext('门店ID'),
      label: baseDetail.shopId
    },
    {
      title: i18n.gettext('门店地址'),
      label: baseDetail.addr
    },
    {
      title: i18n.gettext('邮编'),
      label: baseDetail.postCode
    },
    {
      title: i18n.gettext('门店POI'),
      label: i18n.gettext('查看'),
      isLink: true,
      isMap: true
    },
    {
      title: i18n.gettext('商圈'),
      label: baseDetail.areaName
    },
    {
      title: i18n.gettext('门店电话'),
      label: baseDetail.phone,
      isPhone: true
    },
    // {
    //   title: i18n.gettext('合作方式'),
    //   label: ''
    // },
    {
      title: i18n.gettext('门店品类'),
      label: baseDetail.category && baseDetail.category.map((value) => {
        return currentDish[value]
      }).join(',')
    },
    {
      title: i18n.gettext('KP姓名'),
      label: baseDetail.kpName,
      isPhone: true
    },
    {
      title: i18n.gettext('KP电话'),
      label: baseDetail.kpPhone,
      isPhone: true
    },
    {
      title: i18n.gettext('KP邮箱'),
      label: baseDetail.kpEmail
    },
    {
      title: i18n.gettext('销售姓名'),
      label: baseDetail.bdName
    },
    {
      title: i18n.gettext('销售电话'),
      label: baseDetail.bdPhone,
      isPhone: true
    },
    {
      title: i18n.gettext('关联签约主体名称'),
      label: baseDetail.contractorName
    },
    {
      title: i18n.gettext('关联品牌名称'),
      label: baseDetail.brandName
    },
    {
      title: i18n.gettext('门店logo'),
      isLink: true,
      arrow: true,
      pics: baseDetail.logoImg
    },
    {
      title: i18n.gettext('门脸照片'),
      isLink: true,
      arrow: true,
      pics: baseDetail.shopPics && baseDetail.shopPics.frontPhoto
    },
    {
      title: i18n.gettext('店内环境'),
      isLink: true,
      arrow: true,
      pics: baseDetail.shopPics && baseDetail.shopPics.environmentalPhoto
    }
  ]
}
